var indexOf = [].indexOf;

angular.module('gym.bulkImports').controller('BulkUpdateImportChangeColumn', ["$scope", "$rootScope", "$modal", "$modalInstance", "$http", "$stateParams", "MembershipPlanCategories", "MembershipIntervalUnits", "MembershipPlans", "bulkUpdate", "reloadTable", "checkInvalidRows", "column", "categories", function($scope, $rootScope, $modal, $modalInstance, $http, $stateParams, MembershipPlanCategories, MembershipIntervalUnits, MembershipPlans, bulkUpdate, reloadTable, checkInvalidRows, column, categories) {
  var getCategoryLabel, gym;
  $scope.gym = gym = $rootScope.gym;
  $scope.currency = gym.currency_symbol;
  $scope.column = column;
  $scope.categories = categories;
  $scope.columnLabel = column.name;
  $scope.minDate = moment(gym.today).toDate();
  if (bulkUpdate.update_type === 'membership') {
    MembershipPlans.get('new').then(function(plan) {
      $scope.taxStatusOptions = plan.tax_status_options;
      return $scope.invoiceReceiptCcOptions = [[void 0, 'Disabled']].concat(plan.invoice_receipt_cc_options.map(function(item) {
        return [item, item];
      }));
    });
  }
  $scope.membership_interval_unit_pairs = _.pairs(MembershipIntervalUnits);
  $scope.membershipPlans = MembershipPlans.getList({
    count: 400
  }).$object;
  $scope.currency = $rootScope.gym.currency_symbol;
  $scope.isMembershipImportDateField = function(fieldName) {
    return indexOf.call($scope.isMembershipImportFieldDate, fieldName) >= 0;
  };
  $scope.isMembershipImportSelectField = function(fieldName) {
    return indexOf.call($scope.isMembershipImportFieldSelect, fieldName) >= 0;
  };
  $scope.isMembershipImportNumericField = function(fieldName) {
    return indexOf.call($scope.isMembershipImportNumericInput, fieldName) >= 0;
  };
  $scope.isMembershipImportCurrencyField = function(fieldName) {
    return indexOf.call($scope.isMembershipImportFieldCurrency, fieldName) >= 0;
  };
  $scope.isMembershipImportTextField = function(fieldName) {
    return indexOf.call($scope.isMembershipImportText, fieldName) >= 0;
  };
  $scope.isMembershipImportDateTimeSelectField = function(fieldName) {
    return indexOf.call($scope.isMembershipImportDateTimeSelect, fieldName) >= 0;
  };
  $scope.params = angular.extend({}, bulkUpdate.column_changes);
  $scope.membershipPlanCategories = MembershipPlanCategories.getList({
    count: 1000
  }).$object;
  $scope.membership_interval_unit_pairs = _.pairs(MembershipIntervalUnits);
  $scope.isMembershipImportFieldDate = ['start_date', 'upfront_payment_on', 'recurring_payments_start_on'];
  $scope.isMembershipImportFieldCurrency = ['cost_upfront', 'cost_repeat', 'failure_fee_amount'];
  $scope.isMembershipImportDateTimeSelect = ['classes_interval_unit', 'charge_interval_unit', 'term_unit'];
  $scope.isMembershipImportText = ['label'];
  $scope.isMembershipImportNumericInput = ['classes_limit', 'classes_interval_number', 'charge_interval_number', 'term_number', 'automatic_reschedule_days', 'automatic_reschedule_limit', 'failure_fee_lead_days'];
  $scope.isMembershipImportFieldSelect = ["allow_recurring_bookings", "classes_unlimited", 'tax_exempt', 'send_invoice_receipts', 'skip_auto_reschedule_for_failure_fee', 'skip_invoice_email_for_failure_fee', 'bundle_failure_fee_with_next_payment', 'trial'];
  $scope.updateCategoryLabel = function(selectedCategoryId) {
    return $scope.selectedCategoryLabel = getCategoryLabel(selectedCategoryId);
  };
  getCategoryLabel = function(selectedCategoryId) {
    var selectedCategory;
    selectedCategory = $scope.membershipPlanCategories.find(function(category) {
      return category.id === selectedCategoryId;
    });
    return (selectedCategory != null ? selectedCategory.label : void 0) || '';
  };
  $scope.update = function() {
    var params, selectedLabel, url;
    $scope.isLoading = true;
    url = `/gyms/${gym.id}/bulk_import/bulk_imports/${$stateParams.id}/columns/${column.id}/bulk_set_membership_value`;
    selectedLabel = getCategoryLabel($scope.params[column.mapped_to_field_name]);
    params = {
      value: $scope.params[column.mapped_to_field_name]
    };
    return $http.put(url, params).then((function() {
      $modalInstance.close();
      checkInvalidRows();
      return reloadTable();
    }));
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
